import { createClientId } from "./formatters";

export { createClientId };

export const SYSTEM_LISTS_DEFAULTS = {
  COST_CENTERS:        ["Sede","Pecuária","Galinheiro","Haras"],
  COST_CENTER_CODES:   [
    { name:"Sede", code:"SD" },
    { name:"Haras", code:"HR" },
    { name:"Pecuária", code:"PC" },
    { name:"Avicultura", code:"AV" },
    { name:"Galinheiro", code:"AV" },
  ],
  PURCHASE_CATS:       ["Alimento Animal","Medicamento","Material Elétrico","Lubrificantes","Peças","Material Hidráulico","Alimentos Humano","Limpeza","Limpeza Pesada","Material de Construção"],
  UNITS:               ["Unid.","Litros","Sacos","Kg","g","mL","Caixas","Fardos","Metros","Pacotes","Galões","Toneladas","Doses","Ampolas"],
  ANIMAL_SPECIES:      ["Bovino","Equino","Suíno","Caprino","Ovino","Ave","Outro"],
  ANIMAL_STATUS:       ["Ativo","Vendido","Óbito","Transferido","Descarte"],
  ANIMAL_BREEDS:       [],
  LOT_PURPOSES:        ["Cria","Recria","Engorda","Leite","Reprodução","Confinamento","Outro"],
  VET_TYPES:           ["Vacinação","Consulta","Cirurgia","Exame","Tratamento","Descorna","Castração","Outro"],
  FIN_CATS:            ["Venda de animais","Venda de produção","Compras","Serviços Terceirizados","Folha de Pagamento","Salários","Manutenção","Combustível","Veterinário","Impostos","Outros"],
  ANIMAL_EXIT_REASONS: ["Venda externa","Abate interno","Transferência entre fazendas","Morte","Perda / furto","Doação","Descarte","Consumo interno","Outro"],
  ANIMAL_ENTRY_REASONS:["Compra","Nascimento","Transferência entre fazendas","Retorno","Ajuste de inventário","Outro"],
  ANIMAL_BUYER_DEFAULTS:[
    { name:"Comprador Avulso", cpfCnpj:"", phone:"", address:"", city:"", state:"", notes:"Cadastro inicial" },
  ],
  FIN_CHART_ACCOUNTS: [
    { code:"1.1.01", name:"Caixa e Bancos", type:"Ativo", costCenter:"Sede", taxable:false },
    { code:"1.1.02", name:"Clientes / Contas a Receber", type:"Ativo", costCenter:"Sede", taxable:false },
    { code:"1.1.03", name:"Estoque de Insumos", type:"Ativo", costCenter:"Sede", taxable:false },
    { code:"1.1.04", name:"Animais para Revenda / Reposição", type:"Ativo", costCenter:"Pecuária", taxable:false },
    { code:"2.1.01", name:"Fornecedores a Pagar", type:"Passivo", costCenter:"Sede", taxable:false },
    { code:"2.1.02", name:"Obrigações Trabalhistas", type:"Passivo", costCenter:"Sede", taxable:false },
    { code:"2.1.03", name:"Obrigações Tributárias", type:"Passivo", costCenter:"Sede", taxable:true },
    { code:"3.1.01", name:"Receita com Venda de Animais", type:"Receita", costCenter:"Pecuária", taxable:true },
    { code:"3.1.02", name:"Receita com Venda de Ovos", type:"Receita", costCenter:"Galinheiro", taxable:true },
    { code:"4.1.01", name:"Compra de Animais", type:"Despesa", costCenter:"Pecuária", taxable:true },
    { code:"4.1.02", name:"Compra de Insumos e Estoque", type:"Despesa", costCenter:"Sede", taxable:true },
    { code:"4.1.03", name:"Serviços Terceirizados", type:"Despesa", costCenter:"Sede", taxable:true },
    { code:"4.1.04", name:"Folha de Pagamento", type:"Despesa", costCenter:"Sede", taxable:false },
    { code:"4.1.05", name:"Encargos Trabalhistas", type:"Despesa", costCenter:"Sede", taxable:false },
    { code:"4.1.06", name:"Tributos sobre Compras e Serviços", type:"Despesa", costCenter:"Sede", taxable:true },
  ],
  PAYROLL_CHARGES: [
    { name:"INSS Patronal", pct:20 },
    { name:"FGTS", pct:8 },
    { name:"RAT/SAT", pct:3 },
    { name:"Terceiros / Sistema S", pct:5.8 },
    { name:"Provisionamento 13º", pct:8.33 },
    { name:"Provisionamento Férias + 1/3", pct:11.11 },
  ],
  TAX_REGIMES: [
    { name:"Atual", taxes:["ICMS","ISS","PIS","COFINS","IPI"], notes:"Modelo tributário atual do consumo, mantido para lançamentos históricos e operação vigente enquanto a transição não estiver concluída.", active:true },
    { name:"IVA Dual", taxes:["CBS","IBS","Imposto Seletivo"], notes:"Estrutura preparada para a transição da reforma do consumo com CBS e IBS.", active:true },
  ],
  BOVINE_WEIGHT_CLASS_RULES: [
    { label:"Abaixo de 17@", minAt:"0", maxAt:"17", color:"#EF4444" },
    { label:"17,1@ a 18,8@", minAt:"17.1", maxAt:"18.8", color:"#F59E0B" },
    { label:"18,9@ ou mais", minAt:"18.9", maxAt:"999", color:"#22C55E" },
  ],
  FUNC_ROLES:          ["Peão","Tratador","Veterinário","Motorista","Gerente","Administrativo","Outro"],
  FUNC_STATUS:         ["Ativo","Férias","Afastado","Desligado"],
  STOCK_CATS:          ["Alimento Animal","Medicamento","Material Elétrico","Lubrificantes","Peças","Material Hidráulico","Alimentos Humano","Limpeza","Limpeza Pesada","Material de Construção"],
  CATALOG_PRODUCT_TYPES:[
    "Alimento Animal",
    "Medicamento",
    "Material Elétrico",
    "Lubrificantes",
    "Peças",
    "Material Hidráulico",
    "Alimentos Humano",
    "Limpeza",
    "Limpeza Pesada",
    "Material de Construção",
  ],
  CATALOG_PRODUCT_CATEGORIES:[
    { name:"Ração", typeName:"Alimento Animal" },
    { name:"Sal Mineral", typeName:"Alimento Animal" },
    { name:"Sal Proteinado", typeName:"Alimento Animal" },
    { name:"Suplemento Animal", typeName:"Alimento Animal" },
    { name:"Vermífugo", typeName:"Medicamento" },
    { name:"Analgésico", typeName:"Medicamento" },
    { name:"Antibiótico", typeName:"Medicamento" },
    { name:"Vacina", typeName:"Medicamento" },
    { name:"Cabo Elétrico", typeName:"Material Elétrico" },
    { name:"Disjuntor", typeName:"Material Elétrico" },
    { name:"Lâmpada", typeName:"Material Elétrico" },
    { name:"Óleo de Motor", typeName:"Lubrificantes" },
    { name:"Óleo Hidráulico", typeName:"Lubrificantes" },
    { name:"Graxa", typeName:"Lubrificantes" },
    { name:"Filtros", typeName:"Peças" },
    { name:"Rolamentos", typeName:"Peças" },
    { name:"Mangueira", typeName:"Material Hidráulico" },
    { name:"Conexão", typeName:"Material Hidráulico" },
    { name:"Farinha de Trigo", typeName:"Alimentos Humano" },
    { name:"Óleo Vegetal", typeName:"Alimentos Humano" },
    { name:"Desinfetante", typeName:"Limpeza" },
    { name:"Sabão em Pó", typeName:"Limpeza" },
    { name:"Bucha de Vasilha", typeName:"Limpeza" },
    { name:"Desengraxante", typeName:"Limpeza Pesada" },
    { name:"Detergente Industrial", typeName:"Limpeza Pesada" },
    { name:"Cimento", typeName:"Material de Construção" },
    { name:"Areia", typeName:"Material de Construção" },
    { name:"Tijolo", typeName:"Material de Construção" },
  ],
  GLOBAL_PAYMENT_TERMS: ["À vista", "7 dias", "14 dias", "21 dias", "28 dias", "30 dias", "45 dias", "60 dias", "90 dias"],
  GLOBAL_PAYMENT_METHODS: ["Pix", "Dinheiro", "Boleto", "Cartão", "Transferência", "Cheque"],
  CATALOG_PRODUCT_SUBCATEGORIES:[
    { name:"Engorda", categoryName:"Ração" },
    { name:"Crescimento", categoryName:"Ração" },
    { name:"Postura", categoryName:"Ração" },
    { name:"Em pasta", categoryName:"Vermífugo" },
    { name:"Injetável", categoryName:"Vermífugo" },
    { name:"Comprimido", categoryName:"Vermífugo" },
    { name:"Injetável", categoryName:"Antibiótico" },
    { name:"Oral", categoryName:"Antibiótico" },
    { name:"15W40", categoryName:"Óleo de Motor" },
    { name:"20W50", categoryName:"Óleo de Motor" },
    { name:"5W30", categoryName:"Óleo de Motor" },
    { name:"ISO VG 46", categoryName:"Óleo Hidráulico" },
    { name:"ISO VG 68", categoryName:"Óleo Hidráulico" },
    { name:"Filtro de Ar", categoryName:"Filtros" },
    { name:"Pré-filtro", categoryName:"Filtros" },
    { name:"Mangueira de Alta", categoryName:"Mangueira" },
    { name:"Mangueira de Retorno", categoryName:"Mangueira" },
    { name:"Premium", categoryName:"Farinha de Trigo" },
    { name:"Tradicional", categoryName:"Farinha de Trigo" },
    { name:"Uso Geral", categoryName:"Desinfetante" },
    { name:"Uso Veterinário", categoryName:"Desinfetante" },
    { name:"CP II", categoryName:"Cimento" },
    { name:"CP III", categoryName:"Cimento" },
  ],
  STOCK_UNITS:         [
    { label:"Kg",       defaultQty:"1",   refUnit:"kg" },
    { label:"g",        defaultQty:"1",   refUnit:"g" },
    { label:"Litros",   defaultQty:"1",   refUnit:"L" },
    { label:"mL",       defaultQty:"1",   refUnit:"mL" },
    { label:"Unid.",    defaultQty:"1",   refUnit:"un" },
    { label:"Sacos",    defaultQty:"50",  refUnit:"kg" },
    { label:"Caixas",   defaultQty:"12",  refUnit:"un" },
    { label:"Fardos",   defaultQty:"30",  refUnit:"kg" },
    { label:"Pacotes",  defaultQty:"1",   refUnit:"un" },
    { label:"Galões",   defaultQty:"3.6", refUnit:"L" },
    { label:"Toneladas",defaultQty:"1",   refUnit:"t" },
    { label:"Metros",   defaultQty:"1",   refUnit:"m" },
    { label:"m²",       defaultQty:"1",   refUnit:"m²" },
    { label:"Rolo",     defaultQty:"1",   refUnit:"rolo" },
    { label:"Dose",     defaultQty:"1",   refUnit:"dose" },
    { label:"Ampola",   defaultQty:"1",   refUnit:"ampola" },
    { label:"Frasco",   defaultQty:"1",   refUnit:"frasco" },
    { label:"Balde",    defaultQty:"20",  refUnit:"L" },
  ],
  STOCK_BRANDS:        ["Bayer","Syngenta","BASF","Corteva","FMC","UPL","Nufarm","Adama","Ourofino","Zoetis","MSD Saúde Animal","Elanco","Boehringer Ingelheim","Tortuga","Matsuda","Minerthal","Vaccinar","Guabi","Supremax","DSM","Jacto","Stihl","Husqvarna","Tramontina","John Deere","Case IH","New Holland","Massey Ferguson","Valtra"],
  MACH_CATEGORIES:     ["Máquina","Implemento"],
  MACH_SUBCATEGORIES:  ["Máquina > Trator","Máquina > Colheitadeira","Máquina > Caminhonete","Máquina > Caminhão","Máquina > Moto","Máquina > Quadriciclo","Máquina > Pulverizador","Implemento > Grade","Implemento > Arado","Implemento > Plantadeira","Implemento > Pulverizador de Barra","Implemento > Roçadeira","Implemento > Carreta"],
  MACH_BRAND_LINKS:    ["Máquina > Trator > John Deere","Máquina > Trator > Valtra","Máquina > Trator > Massey Ferguson","Máquina > Colheitadeira > John Deere","Máquina > Colheitadeira > New Holland","Máquina > Caminhonete > Toyota","Máquina > Caminhonete > Chevrolet","Implemento > Grade > Baldan","Implemento > Arado > Tatu Marchesan","Implemento > Plantadeira > John Deere","Implemento > Plantadeira > Jumil","Implemento > Roçadeira > JF","Implemento > Carreta > Implementos São José"],
  MACH_TYPES:          ["Trator","Colheitadeira","Caminhonete","Caminhão","Moto","Quadriciclo","Implemento","Pulverizador","Outro"],
  MACH_STATUS:         ["Operacional","Manutenção","Inativo"],
  FUEL_TYPES:          ["Diesel","Gasolina","Etanol","Gasolina Aditivada","GNV","Elétrico"],
  ENGINE_TYPES:        ["4 Tempos","2 Tempos","Diesel","Elétrico","Híbrido"],
  MACH_MAINTENANCE_PAUSE_REASONS:["Aguardando peça","Aguardando fornecedor","Aguardando aprovação","Máquina liberada para uso emergencial","Equipe indisponível","Condições climáticas","Falta de ferramenta/equipamento","Diagnóstico inconclusivo","Outro"],
  MACH_MAINTENANCE_SERVICE_TYPES:["Troca de óleo","Troca de filtro","Lubrificação","Ajuste","Limpeza técnica","Inspeção","Solda","Elétrica","Hidráulica","Pneus","Freios","Motor","Transmissão","Arrefecimento","Outro"],
  MACH_AIR_PREFILTER_OPTIONS:["Pré-filtro seco","Pré-filtro ciclônico","Pré-filtro de espuma","Pré-filtro Donaldson","Outro"],
  MACH_AIR_FILTER_OPTIONS:["Filtro de ar primário","Filtro de ar secundário","Filtro oval","Filtro cilíndrico","Outro"],
  MACH_OIL_FILTER_OPTIONS:["Filtro roscável","Elemento blindado","Filtro cartucho","Filtro centrífugo","Outro"],
  MACH_FUEL_FILTER_OPTIONS:["Filtro separador de água","Filtro primário de combustível","Filtro secundário de combustível","Elemento diesel","Outro"],
  MACH_LUBRICANT_OIL_OPTIONS:["SAE 15W40","SAE 20W50","10W30 API CK-4","5W30 sintético","Outro"],
  MACH_HYDRAULIC_OIL_OPTIONS:["ISO VG 46","ISO VG 68","UTTO","Hy-Gard","Outro"],
  MACH_TRANSMISSION_OIL_OPTIONS:["80W90","85W140","UTTO","TO-4 30","Outro"],
  MACH_DIFFERENTIAL_OIL_OPTIONS:["80W90","85W140","LS 75W90","API GL-5","Outro"],
  GRASS_TYPES:         ["Braquiária","Andropogon","Mombaça","Tanzânia","Tifton","Coastcross","Piatã","Marandu","Nativo","Outro"],
  WEED_LEVELS:         ["Limpo","Pouco","Médio","Sujo"],
  FEED_TYPES:          ["Pasto","Confinamento","Semi-confinamento","Suplementação a Pasto","Silagem","Feno","Ração Total Misturada (RTM)","Outro"],
  SUPPLEMENT_TYPES:    ["Sal Mineral","Sal Proteinado","Sal Energético","Milho","Sorgo","Farelo de Soja","Bagaço de Cana","Polpa Cítrica","Outro"],
  BIRD_MORTALITY_REASONS:["Comorbidades","Acidentes","Abate para Consumo","Predadores","Outro"],
  TRAINING_TYPES:      ["Adestramento","Salto","Trabalho em Campo","Marcha","Piquete","Trabalho Livre","Banho / Higiene","Ferragem / Casqueamento","Veterinário","Descanso","Outro"],
  HARAS_FEED_TIMES:    ["06:00","11:00","16:00"],
  HARAS_MANAGEMENT_TYPES:["Limpeza de Baia","Casqueamento","Ferrageamento","Banho / Higiene","Troca de Cama","Manejo Sanitário","Outro"],
  HARAS_SPECIAL_DIET_REASONS:["Cólica","Laminite","Síndrome metabólica / obesidade","Convalescença","Baixo escore corporal","Ganho de peso controlado","Úlcera / sensibilidade digestiva","Gestação / lactação","Atleta em recuperação","Outro"],
  HARAS_ACTIVITY_RULES:[
    {name:"Muito pouco ativo", minSessions:"0", maxSessions:"1", suggestedPctBW:"0.35", notes:"Manutenção / exercício mínimo"},
    {name:"Pouco ativo", minSessions:"2", maxSessions:"3", suggestedPctBW:"0.50", notes:"Trabalho leve"},
    {name:"Ativo", minSessions:"4", maxSessions:"5", suggestedPctBW:"0.70", notes:"Trabalho moderado"},
    {name:"Muito ativo", minSessions:"6", maxSessions:"7", suggestedPctBW:"0.90", notes:"Treino frequente"},
    {name:"Trabalho intenso", minSessions:"8", maxSessions:"99", suggestedPctBW:"1.10", notes:"Treino intenso / competição"},
  ],
  HARAS_BREED_RULES:[
    {breed:"Mangalarga Marchador", pctAdjust:"0.00", notes:"Usar base da categoria e ajustar pelo escore corporal e volume de treino."},
    {breed:"Quarto de Milha", pctAdjust:"0.05", notes:"Pode demandar ajuste energético em treino explosivo; confirme com condição corporal."},
    {breed:"Crioulo", pctAdjust:"-0.05", notes:"Tende a exigir controle fino para não superalimentar em baixa atividade."},
    {breed:"Mangalarga Paulista", pctAdjust:"0.00", notes:"Usar base da categoria e ajustar pelo trabalho real."},
  ],
  HARAS_TRAINING_REASONS: [
    { id:1,  icon:"🌧️", label:"Tempo chuvoso" },
    { id:2,  icon:"⛈️", label:"Tempestade / Vendaval" },
    { id:3,  icon:"☀️", label:"Calor extremo" },
    { id:4,  icon:"🐂", label:"Manejo de gado" },
    { id:5,  icon:"🤒", label:"Animal doente / em tratamento" },
    { id:6,  icon:"💊", label:"Animal em medicação" },
    { id:7,  icon:"🏥", label:"Consulta veterinária" },
    { id:8,  icon:"👷", label:"Colaborador indisponível" },
    { id:9,  icon:"🔧", label:"Manutenção do equipamento" },
    { id:10, icon:"🌊", label:"Área alagada" },
    { id:11, icon:"📋", label:"Ordem do administrador" },
    { id:12, icon:"✏️", label:"Outro (descrever)" },
  ],
  POI_CATEGORIES:      ["Pastos","Casas","Galpões","Curral","Baia"],
  HARAS_BREEDS:        ["Mangalarga Marchador","Quarto de Milha","Campolina","Lusitano","Puro Sangue Inglês (PSI)","Árabe","Paint Horse","Appaloosa","Andaluz","Frísio","Crioulo","Pantaneiro","Outro"],
  HARAS_COATS:         [
    {name:"Alazão", hex:"#C1440E"},
    {name:"Castanho", hex:"#6B3A2A"},
    {name:"Zaino", hex:"#1A0A00"},
    {name:"Tordilho", hex:"#A0A0A0"},
    {name:"Ruão", hex:"#C97B47"},
    {name:"Palomino", hex:"#D4A853"},
    {name:"Bai", hex:"#8B5E3C"},
    {name:"Overo", hex:"#F5F0E8"},
    {name:"Tobiano", hex:"#E8D5B0"},
    {name:"Appaloosa", hex:"#D4C5A9"},
    {name:"Cremelo", hex:"#F5ECD7"},
    {name:"Perlino", hex:"#EDD9B0"},
    {name:"Buckskin", hex:"#C8A86B"},
    {name:"Grulla", hex:"#8B8680"},
    {name:"Outra", hex:"#64748B"},
  ],
  PROVIDER_SPECIALTIES:["Eletricista","Pedreiro / Construção","Mecânico","Torneiro Mecânico","Soldador","Veterinário","Agrônomo","Nutricionista Animal","Topógrafo","Pintor","Encanador","Outro"],
  DEV_REASONS:         ["Normal","Estragou","Quebrou","Perdeu","Venceu","Troca de tamanho","Outro"],
  EMPLOYEE_DELETE_REASONS:["Desligamento","Pedido de demissão","Cadastro duplicado","Transferência de estrutura","Usuário criado indevidamente","Inativação definitiva","Outro"],
  EMPLOYEE_REACTIVATE_REASONS:["Recontratação","Correção de desativação indevida","Retorno de afastamento","Reativação operacional","Conta necessária para continuidade do trabalho","Outro"],
  POI_STATUSES:        ["Ativo","Inativo","Em Manutenção"],
  WATER_STATUS:        ["Limpa","Suja","Vazia","Sem Avaliação"],
  TROUGH_STATUS:       ["Em Conformidade","Danificado","Sujo","Sem Avaliação"],
  BED_THICKNESS:       ["Em Conformidade","Fina Demais","Grossa","Média","Sem Avaliação"],
  BED_MOISTURE:        ["Seca","Úmida","Molhada","Sem Avaliação"],
  ORDER_DENY_REASONS:  ["Preço acima do orçamento","Item não prioritário no momento","Produto já em estoque suficiente","Fornecedor sem cadastro aprovado","Pedido duplicado","Aguardando aprovação de verba","Item não compatível com as necessidades","Cotação insuficiente","Outro motivo"],
  ORDER_NO_QUOTE_REASONS:["Urgência operacional","Fornecedor único / exclusividade","Item indisponível para cotação no prazo","Continuidade de operação / evitar parada","Compra emergencial de manutenção","Reposição imediata de item crítico","Baixo valor / custo administrativo da cotação inviável","Regularização de compra já executada em campo"],
  SERVICE_TITLES:      ["Manutenção de Cerca","Manutenção de Água","Manutenção de Cocho","Manutenção de Estradas","Limpeza de Curral","Aplicação de Herbicida","Capina Manual","Roçagem","Manutenção Elétrica","Manutenção Hidráulica","Pintura","Construção","Reforma","Revisão de Maquinário","Vacinação em Massa","Outro"],
  SERVICE_EXEC_TYPES:  ["Interno (Colaborador)","Externo (Prestador)","Misto (Colaborador + Prestador)"],
  SERVICE_PAY_METHODS: ["À Vista","Parcelado","Boleto","PIX","Transferência","Cheque","A Combinar"],
  SERVICE_DENY_REASONS:["Orçamento acima do esperado","Serviço não prioritário","Aguardando verba","Prestador não aprovado","Serviço resolvido internamente","Outro motivo"],
  SERVICE_PHOTO_TITLES: ["Foto Motivo","Foto Inicial","Foto Durante Execução","Foto Conclusão","Foto Peça Estragada","Foto Peça Nova","Foto do Defeito","Foto do Reparo","Foto Material Utilizado","Foto Antes","Foto Depois","Outro Registro"],
  TASK_PAUSE_REASONS:   ["Aguardando material","Falta de peça","Falta de ferramenta","Aguardando autorização","Aguardando fornecedor","Condições climáticas","Equipamento indisponível","Equipe redirecionada para urgência","Problema técnico identificado","Aguardando decisão do gestor"],
  FEED_PAUSE_REASONS:   ["Troca de dieta","Falta de produto no estoque","Orientação veterinária / zootécnica","Jejum programado","Animal em adaptação","Problema no cocho / fornecimento","Clima extremo","Lote temporariamente fora do manejo","Outro"],
  VET_PAUSE_REASONS:    ["Aguardando exame","Aguardando medicamento","Animal em observação","Aguardando contenção / manejo","Aguardando autorização","Condição clínica instável","Condições climáticas","Equipe redirecionada para urgência","Outro"],
};

export const T = {
  bg:"#0A0E14", card:"#111827", card2:"#1A2233", border:"#1F2D3D",
  text:"#E2E8F0", muted:"#64748B", accent:"#3B82F6", green:"#10B981",
  red:"#EF4444", yellow:"#F59E0B", purple:"#8B5CF6",
};

export const COST_CENTERS   = ["Sede","Pecuária","Galinheiro","Haras"];
export const CC_ICONS       = { "Sede":"🏠","Pecuária":"🐄","Galinheiro":"🐔","Haras":"🐴" };
export const CC_COLORS      = { "Sede":"#7C3AED","Pecuária":"#D97706","Galinheiro":"#059669","Haras":"#DB2777" };


export const DEFAULT_SKIP_REASONS = [
  { id:1,  icon:"🌧️", label:"Tempo chuvoso" },
  { id:2,  icon:"⛈️", label:"Tempestade / Vendaval" },
  { id:3,  icon:"☀️", label:"Calor extremo" },
  { id:4,  icon:"🐂", label:"Manejo de gado" },
  { id:5,  icon:"🤒", label:"Animal doente / em tratamento" },
  { id:6,  icon:"💊", label:"Animal em medicação" },
  { id:7,  icon:"🏥", label:"Consulta veterinária" },
  { id:8,  icon:"👷", label:"Colaborador indisponível" },
  { id:9,  icon:"🔧", label:"Manutenção do equipamento" },
  { id:10, icon:"🌊", label:"Área alagada" },
  { id:11, icon:"📋", label:"Ordem do administrador" },
  { id:12, icon:"✏️", label:"Outro (descrever)" },
];

export const MACH_TYPES = ["Trator","Colheitadeira","Caminhonete","Caminhão","Implemento","Bomba","Gerador","Outro"];
export const FUEL_TYPES = ["Diesel","Gasolina","Etanol","Gasolina Aditivada","Arla 32","Óleo Lubrificante 2T","Óleo Lubrificante 4T","Sem combustível"];
export const ENGINE_TYPES = ["4 Tempos","2 Tempos","Diesel","Elétrico","N/A"];
export const FUEL_KEYWORDS = ["diesel","gasolina","etanol","arla","combustivel","combustível","álcool","alcool","querosene","biodiesel","lubrificante","óleo 2t","oleo 2t","óleo 4t","oleo 4t"];

export function isCompactViewport(){
  if (typeof window === "undefined") return false;
  return window.innerWidth <= 768;
}

export const STOCK_MOV_TYPES = [
  { id:"entrada",      delta:+1 },
  { id:"saida",        delta:-1 },
  { id:"quebra",       delta:-1 },
  { id:"devolucao",    delta:+1 },
  { id:"ajuste",       delta: 0 },
  { id:"transferencia",delta: 0 },
];

export function calcStockQtyFromMovements(movements, itemId) {
  return (movements||[])
    .filter(m => String(m.itemId) === String(itemId))
    .reduce((sum, m) => {
      if (m.type === "ajuste") return Number(m.qty) || 0;
      if (m.type === "transferencia") {
        return sum + ((m.delta === "entrada" ? 1 : -1) * Math.abs(Number(m.qty)||0));
      }
      const movType = STOCK_MOV_TYPES.find(t=>t.id===m.type);
      return sum + ((movType?.delta || 0) * Math.abs(Number(m.qty)||0));
    }, 0);
}

export function enrichStockItemsWithQty(items, movements) {
  return (items||[]).map(i => ({...i, quantity: calcStockQtyFromMovements(movements, i.id)}));
}

// Fase 7 — constantes movidas do App.jsx
const ANIMAL_SPECIES= ["Bovino","Equino","Suíno","Caprino","Ovino","Ave","Outro"];
const DEFAULT_VISIBLE_FARM_SPECIES = ["Bovino","Equino","Ovino"];
const FARM_COLORS   = ["#3B82F6","#10B981","#F59E0B","#EF4444","#8B5CF6","#EC4899","#14B8A6","#F97316"];
const FARM_EMOJIS   = [
  { value:"🌾", label:"🌾", title:"Fazenda" },
  { value:"🏡", label:"🏡", title:"Casa" },
  { value:"🐄", label:"🐄", title:"Rebanho" },
  { value:"🌽", label:"🌽", title:"Milho" },
  { value:"🍃", label:"🍃", title:"Folha" },
  { value:"🌻", label:"🌻", title:"Girassol" },
  { value:"🌿", label:"🌿", title:"Verde" },
  { value:"🥚", label:"🥚", title:"Ovos" },
  { value:"🐴", label:"🐴", title:"Cavalo da fazenda", emojiType:"horse" },
  { value:"🐮", label:"🐮", title:"Rebanho da fazenda", emojiType:"cattle" },
];
const COLLAB_LEVELS = [
  { id:1, label:"Nível 1", color:"#64748B", icon:"1️⃣",
    desc:"Acesso básico — não visualiza vistorias", canSeeInspections:false },
  { id:2, label:"Nível 2", color:"#3B82F6", icon:"2️⃣",
    desc:"Vê vistorias finalizadas do seu centro de custo", canSeeInspections:true, canSeeHistory:false },
  { id:3, label:"Nível 3", color:"#8B5CF6", icon:"3️⃣",
    desc:"Vê vistorias + histórico + pode comentar nos achados", canSeeInspections:true, canSeeHistory:true, canComment:true },
];

export { ANIMAL_SPECIES, DEFAULT_VISIBLE_FARM_SPECIES, FARM_COLORS, FARM_EMOJIS, COLLAB_LEVELS };
